import LearningCenterRoutes from 'Pages/LearningCenter/routes';
import ResourcesRoutes from 'Pages/Resources/routes';
import NewsRoomRoutes from 'Pages/NewsRoom/routes';

const PageAccreditation = () => import(/* webpackChunkName: 'PageAccreditation' */ 'Components/PageAccreditation/PageAccreditation');
const PageContactUs = () => import(/* webpackChunkName: 'PageContactUs' */ 'Components/PageContactUs/PageContactUs');
const PageFaqs = () => import(/* webpackChunkName: 'PageFaqs' */ 'Components/PageFaqs/PageFaqs');
const PageFarm = () => import(/* webpackChunkName: 'PageFarm' */ 'Components/PageFarm/PageFarm');
const PageFarmOwners = () => import(/* webpackChunkName: 'PageFarmOwners' */ 'Components/PageFarmOwners/PageFarmOwners');
const PageInvestment = () => import(/* webpackChunkName: 'PageInvestment' */ 'Components/PageInvestment/PageInvestment');
const PageInvestmentComplete = () => import(/* webpackChunkName: 'PageInvestmentComplete' */ 'Components/PageInvestmentComplete/PageInvestmentComplete');
const PageInvestors = () => import(/* webpackChunkName: 'PageInvestors' */ 'Components/PageInvestors/PageInvestors');
const PageListingOffering = () => import(/* webpackChunkName: 'PageListingOffering' */ 'Components/PageListingOffering/PageListingOffering');
const PageLogin = () => import(/* webpackChunkName: 'PageLogin' */ 'Components/PageLogin/PageLogin');
const PageMain = () => import(/* webpackChunkName: 'PageMain' */ 'Components/PageMain/PageMain');
const PagePledge = () => import(/* webpackChunkName: 'PagePledge' */ 'Components/PagePledge/PagePledge');
const PagePrivacy = () => import(/* webpackChunkName: 'PagePrivacy' */ 'Components/PagePrivacy/PagePrivacy');
const PageProfile = () => import(/* webpackChunkName: 'PageProfile' */ 'Components/PageProfile/PageProfile');
const PageSignUp = () => import(/* webpackChunkName: 'PageSignUp' */ 'Components/PageSignUp/PageSignUp');
const PageSignUpSocial = () => import(/* webpackChunkName: 'PageRegister' */ 'Components/PageSignUpSocial/PageSignUpSocial');
const PageTerms = () => import(/* webpackChunkName: 'PageTerms' */ 'Components/PageTerms/PageTerms');
const PageError = () => import(/* webpackChunkName: 'PageError' */ 'Components/PageError/PageError');
const PageCompany = () => import(/* webpackChunkName: 'PageCompany' */ 'Components/PageCompany/PageCompany');
const PageFarmValue = () => import(/* webpackChunkName: 'PageFarmValue' */ 'Components/PageFarmValue/PageFarmValue');
const PageFarmValueStates = () => import(/* webpackChunkName: 'PageFarmValueStates' */ 'Components/PageFarmValueStates/PageFarmValueStates');
const PageResetPassword = () => import(/* webpackChunkName: 'PageResetPassword' */ 'Components/PageResetPassword/PageResetPassword');
const PageWireInstructions = () => import(/* webpackChunkName: 'PageWireInstructions' */ 'Components/PageWireInstructions/PageWireInstructions');

export default [
  {
    path: '/',
    name: 'home',
    component: PageMain,
    meta: {
      store: ['farm/getList'],
      // store: ['farm/getList', 'learningCenter/getRandomPostsFromCategory'],
    },
  },
  {
    path: '/home',
    redirect: { name: 'home' },
  },
  {
    path: '/careers',
    beforeEnter() {
      window.location.href = 'https://acretrader-inc.rippling-ats.com/';
    },
  },
  {
    path: '/explainer',
    name: 'home-explainer',
    component: PageMain,
    meta: {
      store: ['farm/getList'],
      requiresComponents: [
        () => import(/* webpackChunkName: 'ExplainerVideo' */ 'Components/ExplainerVideo/ExplainerVideo'),
      ],
    },
  },
  {
    path: '/sb',
    name: 'home-sb',
    component: PageMain,
    meta: {
      store: ['farm/getList'],
    },
  },
  {
    path: '/mwf',
    name: 'home-mwf',
    component: PageMain,
    meta: {
      store: ['farm/getList'],
    },
  },
  {
    path: '/meb',
    name: 'home-meb',
    component: PageMain,
    meta: {
      store: ['farm/getList'],
    },
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: PageSignUp,
    meta: {
      skipRedirectToRoute: true,
      store: ['page/getPageData'],
    },
    children: [
      {
        path: 'accreditation',
        name: 'sign-up-accreditation',
      }, {
        path: 'investment-experience',
        name: 'sign-up-investment-experience',
      }, {
        path: 'complete',
        name: 'sign-up-complete',
      },
    ],
  },
  {
    path: '/sign-up-social',
    name: 'sign-up-social',
    component: PageSignUpSocial,
    meta: {
      skipRedirectToRoute: true,
      requiresAuth: true,
      requiresProfileData: true,
    },
    children: [
      {
        path: 'accreditation',
        name: 'sign-up-social-accreditation',
      }, {
        path: 'investment-experience',
        name: 'sign-up-social-investment-experience',
      },
    ],
  },
  {
    path: '/sign-in',
    name: 'sign-in',
    component: PageLogin,
    meta: {
      skipRedirectToRoute: true,
      store: ['page/getPageData'],
    },
  },
  {
    path: '/accreditation',
    name: 'accreditation',
    component: PageAccreditation,
    meta: {
      requiresAuth: true,
      skipRedirectToRoute: true,
      store: ['profile/getProfileData', 'page/getPageData'],
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: PageResetPassword,
  },
  {
    path: '/profile/investments/wire/:id',
    name: 'wire',
    component: PageWireInstructions,
    meta: {
      requiresAuth: true,
      store: ['investment/getInvestmentSingleData'],
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: PageProfile,
    meta: {
      requiresAuth: true,
      store: [
        'investment/getInvestmentList',
        'profile/getInvestmentProfileList',
        'profile/getInvestmentProfileAccreditationIssueList',
        'login/getLoginHistoryData',
        'page/getPageData',
        'farm/getList',
      ],
    },
    children: [
      {
        path: 'wallet/wallet',
        redirect: { name: 'profile-tab', params: { tab: 'wallet' },
        },
      },
      {
        path: 'user-profile',
        redirect: { name: 'profile-tab', params: { tab: 'accounts' },
        },
      },
      {
        path: 'user-profile/profile',
        redirect: { name: 'profile-tab', params: { tab: 'accounts' },
        },
      },
      {
        path: ':tab',
        name: 'profile-tab',
        meta: {
          skipScrollTabTablet: true,
        },
        children: [
          {
            path: ':nestedTab',
            name: 'profile-tab-tab',
            meta: {
              skipScrollTab: false,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/explore',
    name: 'explore',
    component: PageListingOffering,
    meta: {
      store: ['farm/getList', 'farm/getClosedSuccessfullyList', 'page/getPageData'],
    },
  },
  {
    path: '/investors',
    name: 'investors',
    component: PageInvestors,
    meta: {
      store: ['page/getPageData'],
    },
  },
  ...ResourcesRoutes,
  {
    path: '/resources/investors',
    redirect: { name: 'investors' },
  },
  {
    path: '/resources/farm-owners',
    name: 'farm-owners',
    component: PageFarmOwners,
    meta: {
      store: ['page/getPageData'],
    },
  },
  {
    path: '/resources/farmland-values',
    name: 'farmland-values',
    component: PageFarmValue,
    meta: {
      skipRouteLoading: true,
      storeModules: [{
        name: 'valueTools',
        module: () => import(/* webpackChunkName: 'valueToolsStoreModule' */ 'Store/valueTools'),
      }],
    },
    redirect: to => `${to.path}/farmland-returns`,
    children: [
      {
        path: 'farmland-returns',
        name: 'farmland-returns',
        component: PageFarmValue,
        meta: {
          skipScrollTab: true,
          store: ['page/getPageData'],
        },
      },
      {
        path: 'farmland-prices',
        name: 'farmland-prices',
        component: PageFarmValue,
        meta: {
          skipScrollTab: true,
          store: ['page/getPageData'],
        },
      },
      {
        path: 'rental-rates',
        name: 'rental-rates',
        component: PageFarmValue,
        meta: {
          skipScrollTab: true,
          store: ['page/getPageData'],
        },
      },
      {
        path: 'rankings',
        name: 'rankings',
        component: PageFarmValue,
        meta: {
          skipScrollTab: true,
          store: ['page/getPageData'],
        },
      },
    ],
  },
  {
    path: '/resources/:slug-farmland-:tab',
    name: 'values-state-single',
    component: PageFarmValueStates,
    meta: {
      skipScrollTab: true,
      storeModules: [{
        name: 'valueTools',
        module: () => import(/* webpackChunkName: 'valueToolsStoreModule' */ 'Store/valueTools'),
      }],
      store: ['valueTools/getStateMapData'],
    },
  },
  ...LearningCenterRoutes,
  {
    path: '/company',
    name: 'company',
    component: PageCompany,
    meta: {
      store: ['page/getPageData'],
    },
  },
  {
    path: '/company/terms',
    name: 'terms',
    component: PageTerms,
    meta: {
      store: ['page/getPageData'],
    },
  },
  {
    path: '/company/privacy',
    name: 'privacy',
    component: PagePrivacy,
    meta: {
      store: ['page/getPageData'],
    },
  },
  {
    path: '/company/contact-us',
    name: 'contact-us',
    component: PageContactUs,
    meta: {
      store: ['page/getPageData'],
    },
  },
  ...NewsRoomRoutes,
  {
    path: '/faq',
    name: 'faq',
    component: PageFaqs,
    meta: {
      store: ['page/getPageData'],
    },
    children: [
      {
        path: ':sectionSlug',
        name: 'faq-section',
        children: [
          {
            path: ':itemSlug',
            name: 'faq-item',
          },
        ],
      },
    ],
  },
  {
    path: '/404',
    name: '404',
    component: PageError,
  },
  {
    path: '/error',
    name: 'error',
    component: PageError,
    children: [
      {
        path: ':code',
        name: 'error-code',
      },
    ],
  },
  {
    path: '/:slug/investment-process/:investmentId/complete',
    name: 'investment-process-complete',
    component: PageInvestmentComplete,
    meta: {
      store: ['farm/getFarmData', 'profile/getInvestmentProfileList'],
      requiresAuth: true,
      requiresAccreditation: true,
      onLogoutRedirect: { name: 'farm' },
      requiresEmailVerification: true,
      onEmailVerificationRedirect: route => ({ ...route, name: 'farm' }),
    },
  },
  {
    path: '/:slug/pledge/complete',
    name: 'pledge-complete',
    component: PageInvestmentComplete,
    meta: {
      store: ['farm/getFarmData'],
      requiresAuth: true,
      requiresAccreditation: true,
      onLogoutRedirect: { name: 'farm' },
      requiresEmailVerification: true,
      onEmailVerificationRedirect: route => ({ ...route, name: 'farm' }),
    },
  },
  {
    path: '/:slug/pledge',
    name: 'pledge',
    component: PagePledge,
    meta: {
      store: ['farm/getFarmData'],
      requiresAuth: true,
      requiresAccreditation: true,
      requiresConfirmLogout: true,
      onLogoutRedirect: { name: 'farm' },
    },
  },
  {
    path: '/:slug/investment-process',
    name: 'investment-process',
    component: PageInvestment,
    meta: {
      store: ['farm/getFarmData', 'profile/getInvestmentProfileList'],
      requiresAuth: true,
      requiresAccreditation: true,
      requiresConfirmLogout: true,
      requiresEmailVerification: true,
      onEmailVerificationRedirect: route => ({ ...route, name: 'farm' }),
      onLogoutRedirect: { name: 'farm' },
    },
    children: [
      {
        path: ':investmentId/:step',
        name: 'investment-process-step',
        meta: {
          requiresConfirmLogout: true,
          store: ['profile/getInvestmentProfileList', 'investment/getInvestmentList'],
        },
      },
    ],
  },
  {
    path: '/:slug',
    name: 'farm',
    component: PageFarm,
    meta: {
      store: ['farm/getFarmData'],
      updateStoreData: true,
    },
    children: [
      {
        path: 'maps',
        name: 'farm.maps',
        meta: {
          skipScrollTab: true,
        },
      },
      {
        path: 'financials',
        name: 'farm.financials',
        meta: {
          skipScrollTab: true,
          requiresAuth: true,
          onLogoutRedirect: { name: 'farm' },
        },
      },
      {
        path: 'documents',
        name: 'farm.documents',
        meta: {
          skipScrollTab: true,
          requiresAuth: true,
          onLogoutRedirect: { name: 'farm' },
        },
      },
      {
        path: 'rating',
        name: 'farm.rating',
        meta: {
          skipScrollTab: true,
        },
      },
    ],
  },
  {
    path: '*',
    redirect: { name: '404' },
  },
];
